<template>
    <div id="contenedor-adjudicaciones-main">
      <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: 'AdjudicacionesMain',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
